import styled, {
  css,
  DefaultTheme,
  ThemedStyledProps,
} from 'styled-components';
import { baseStyles } from '../styles';
import { HeadingStyleProps } from './types';

function getTypographyStyle({
  theme,
  $level,
  $variant,
}: ThemedStyledProps<HeadingStyleProps, DefaultTheme>) {
  const headingVariants = theme.typography.variants[`h${$level}`];
  const variantKey = $variant === 'desktop' ? 'default' : 'mobile';
  const style = headingVariants[variantKey];
  return style ? css(style) : undefined;
}

export const Root = styled.h1<HeadingStyleProps>`
  ${getTypographyStyle}
  ${baseStyles}
  margin: 0px;
`;
